export const templates: any = {
    'PDP': [
        [
            ['s'], 
            ['s'],
        ],
        [
            ['s'],
        ],
        [
            ['h'],
        ],
        [
            ['s'],
            ['s'],
        ],
        [
            ['h'],
        ]
    ],
    'TEST': [
        [
            ['s']
        ]
    ],
    'LIST': [
        [
            ['s'],
            ['s']
        ]
    ],
    'LOADINGLIST': [
        [
            ['s'],['s']
        ],
        [
            ['s'],['s']
        ],
        [
            ['s'],['s']
        ],
        [
            ['s'],['s']
        ],
    ],
    'SOCIAL_PDP_DESKTOP': [
        [
            ['s'], ['s'],
        ],
        [
            ['s','s'],['v']
        ],
        [
            ['v'],['s','s']
        ],
    ],

    'LOADING_SOCIAL_PDP_DESKTOP': [
        [
            ['s'], ['s'],
        ],
        [
            ['v'],['s','s']
        ],
        [
            ['v']
        ],
        [
            ['s','s'],['v']
        ],
    ],
};